import React, { useEffect, useState } from "react";
import { Amplify } from "aws-amplify";
import { getCurrentUser, signOut, fetchAuthSession } from '@aws-amplify/auth';
import awsExports from "./aws-exports";
import "@aws-amplify/ui-react/styles.css";
import { Authenticator } from "@aws-amplify/ui-react";

Amplify.configure(awsExports);

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Attempt to fetch the current authenticated user
    getCurrentUser()
      .then((user) => {
        setUser(user)
        console.log("===> user:", user);
        fetchAuthSession().then(session=>{
          console.log("===> tokens:", session.tokens);
          if(session.tokens){
            console.log("id token", session.tokens.idToken)
            console.log("access token", session.tokens.accessToken)
          }
        })
      }).catch(() => console.log("Not signed in"));
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut();
      setUser(null);
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  return (
    <Authenticator socialProviders={['google']} loginMechanisms={['email']} signUpAttributes={['email']}> 
      {({ user }) => (
        <main>
          <div>
            <p>Welcome, {user.username}!</p>
            <p>Email: {user.signInDetails ? user.signInDetails.loginId : ""}</p>
            <button onClick={handleSignOut}>Sign Out</button>
          </div>
        </main>
      )}
    </Authenticator>
  );
}

export default App;